/**
 * Auth Provider
 *
 * Provides a simple, mockable interface for checking auth state.
 * Used by services (like FollowStatusService) that need to check
 * authentication without direct dependency on auth state signals.
 */

import { inject } from "../../di";
import type { IAuthProvider, IAuthState, ICurrentUser } from "./types";

/**
 * DI-based auth provider.
 * Uses the injected auth state for all operations.
 */
export class AuthProvider implements IAuthProvider {
  @inject<IAuthState>("authState")
  private authState!: IAuthState;

  isAuthenticated(): boolean {
    return this.authState.isAuthenticated.get();
  }

  getCurrentUser(): ICurrentUser | undefined {
    return this.authState.currentUser.get();
  }

  getAccessToken(): string | undefined {
    return this.authState.accessToken.get();
  }
}
